/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Section_AdditionalInputs */



/**
* | output |
* | --- |
* | "Additional Features" |
*
* @param {Signup_Compare_Section_AdditionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_section_additional = /** @type {((inputs?: Signup_Compare_Section_AdditionalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Section_AdditionalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "de") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "it") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "es") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Additional Features")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Additional Features")
	return /** @type {LocalizedString} */ ("Additional Features")
});